export const environment = {
  version: '4.19.0',
  production: true,
  tokenKey: 'api_token',
  apiBaseUrl: 'https://tecservice.app/api/v1/',
  cryptoKey: 'bxRIDUqlBOO9QWRxutD6dp2nscXEl96gkdfjA4Kfkd9',
  storagePrefix: '',
  storageEncryption: true,
};
